import React, { useEffect, useState } from 'react'
import { Chip, Dialog, DialogActions, DialogContent, DialogTitle, FormControlLabel, IconButton, LinearProgress, MenuItem, Radio, RadioGroup, Select, Tooltip } from "@mui/material";
import { Add, Edit } from '@mui/icons-material';
import { useAlert } from '../../../../context/AlertContext';
import { ResponseSelector } from '../../response/components/ResponseSelector';
import suggestionServices from '../suggestionServices';

const colorList = [
    {value:"default",title:"White"},
    {value:"primary",title:"Blue"},
    {value:"secondary",title:"Purple"},
    {value:"error",title:"Red"},
    {value:"info",title:"Sky Blue"},
    {value:"success",title:"Green"},
    {value:"warning",title:"Orange"},
]


function SuggesionForm({data,refreshList,masters }) {

    const {AppAlert} = useAlert();
    const [optionId,setOptionId] = useState('');
	const [optionTitle,setOptionTitle] = useState("");
    const [dialogStatus, setDialogStatus] = useState(false);
    
    const [color,setColor] = useState("default");
    const [variant,setVariant] = useState("outlined");

    const [savingInProgress, setSavingStatus] = useState(false);


    


    const responseSelectCallback = (responseMessage) => {
		setOptionId(responseMessage.id);
	}


    const updateData = ()=>{
        if(data){
            setOptionId(data.optionId)
            setOptionTitle(data.optionTitle)
            setColor(data.color)
            setVariant(data.variant)
            setDialogStatus(true)
        }
    }

    const addNew = () =>{
        setOptionId("");
        setOptionTitle("");
        setColor(data.color)
        setVariant(data.color)
        setDialogStatus(true)
    }

    const handleClose  = () =>{
        setDialogStatus(false);
    }

    const onSubmit = () => {
        let payload ={
            optionId : optionId,
            optionTitle: optionTitle,
            color:color,
            variant:variant
        }
        if(data){
            payload.id = data.id;
        }
        suggestionServices.save(payload).then(res=>{
            AppAlert(res.msg);
            setDialogStatus(false);
            refreshList()
        }).catch(error=>{
            AppAlert(error.msg,"error");
        }).finally(()=>{
            setSavingStatus(false);
        })
    }    

    return (
        <>
            {!data &&
                <Tooltip title="Add New">
                    <button type="button" className="btn btn-primary" onClick={addNew} ><Add/> Add New</button>
                </Tooltip>
            }
            {data &&
                <Tooltip title="Update">
                    <IconButton onClick={updateData} style={{padding:"0px"}}>
                        <Edit/>
                    </IconButton>
                </Tooltip>
            }
            <Dialog
                open={dialogStatus}
                keepMounted
                onClose={handleClose}
                fullWidth={true}
                maxWidth="md"
            >

                <DialogContent>
                    <div className='row my-3'>
                        <div className='col-md-6'>
                            <div className="form-floating">
                                <input type="text" className="form-control" value={optionTitle} onChange={(e)=>setOptionTitle(e.target.value)} placeholder="Suggestion Title" />
                                <label>Suggestion Title</label>
                            </div>
                        </div>
                        <div className='col-md-4 p-2'>
                            Selected : {optionId} <ResponseSelector callBack={responseSelectCallback} />
                        </div>
                        <div className='col-md-2 p-2'>
                            <button onClick={onSubmit} className='btn btn-primary' disabled={optionId==="" || optionTitle === ""} >Save</button>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-md-12'><h5>Choose Your Style</h5></div>
                        
                        <div className='col-md-6'>
                            
                            <Select
                                value={color}
                                onChange={(e)=>setColor(e.target.value)}
                            >
                                {colorList.map(color=>
                                    <MenuItem value={color.value}>{color.title}</MenuItem>
                                )}
                            </Select>
                        </div>
                        <div className='col-md-6'>
                            <RadioGroup
                                value={variant}
                                onChange={(e)=>setVariant(e.target.value)}
                            >
                                <FormControlLabel value="outlined" control={<Radio />} label="Outlined" />
                                <FormControlLabel value="filled" control={<Radio />} label="Filled" />

                            </RadioGroup>
                        </div>

                        <div className='col-md-12'>
                            <Chip variant={variant} color={color} className='mt-1' label={optionTitle} />
                        </div>
                        
                    </div>
                </DialogContent>
            </Dialog>

        </>
    )
}

export default SuggesionForm
